export const PRODUCT_CARD_IMAGE_ASPECT_RATIO = 0.83 // width / height
